const svgsContext:__WebpackModuleApi.RequireContext = require.context('../../../styling/custom-theme/images/symbols/', false, /.svg$/);

const svgs = svgsContext.keys().map(svgsContext);

module.exports = svgs;
